import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_testimonials()
})

function dhsv_vc_testimonials() {
  $('.dhsv_vc_testimonials').each(function () {})
}
